import React, { useEffect, useState, useContext } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import OutlinedInput from "@mui/material/OutlinedInput";

import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { lerDataDaLista } from "../../formatoDataDaLista";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { ClinicaContext } from "../../../../../../../shared/context/clinica-context";
import { useLoading } from "../../../../../../../shared/context/LoadingContext";

import toast from "react-hot-toast";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const facesDentes = ["D", "M", "O/I", "P/L", "V"];

const todosOsDentes = [
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "51",
  "52",
  "53",
  "54",
  "55",
  "61",
  "62",
  "63",
  "64",
  "65",
  "71",
  "72",
  "73",
  "74",
  "75",
  "81",
  "82",
  "83",
  "84",
  "85",
  "Arcada Superior",
  "Arcada Inferior",
  "Arcadas",
];

function ModalVerEditarTratamentoIsolado({
  sendRequest,
  auth,
  dados,
  open,
  tipoModal,
  handleCloseModal,
  handleModalSubmitSuccess,
}) {
  const clinica = useContext(ClinicaContext);

  const { startLoading, stopLoading } = useLoading();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [relatorio, setRelatorio] = useState(dados.relatorio || "");
  /* `lerDataDaLista` e não um `moment` com o formato à mão.
   *
   * A leitura tolerante aceitava uma cadeia sem horas e punha meia-noite sem
   * se queixar — e o que daqui sai é escrito em `data_inicio_execucao`, que é a
   * marcação na agenda. Era por aqui que o tratamento desaparecia da agenda ao
   * ser executado depois de um cancelamento. */
  const [dataInicioExecucao, setDataInicioExecucao] = useState(
    lerDataDaLista(dados.data_inicio_execucao)
  );
  const [dataFimExecucao, setDataFimExecucao] = useState(
    lerDataDaLista(dados.data_fim_execucao)
  );

  const [selectedProcedure, setSelectedProcedure] = useState(
    dados.tratamento?._id || ""
  );
  const [tratamentos, setTratamentos] = useState([]);
  const [allTratamentos, setAllTratamentos] = useState([]);

  // Estados para dentes e faces
  const [dentes, setDentes] = useState(dados.dente ? [dados.dente] : []);
  const [faces, setFaces] = useState(dados.faces || []);
  const [listaDentes, setListaDentes] = useState(todosOsDentes);
  const [showDentes, setShowDentes] = useState(false);
  const [showFaces, setShowFaces] = useState(false);

  // Estados para validação
  const [erroDentes, setErroDentes] = useState("");
  const [erroFaces, setErroFaces] = useState("");

  // Estados para controle de alteração de tratamento
  const [tratamentoOriginal, setTratamentoOriginal] = useState(null);
  const [tratamentoAtual, setTratamentoAtual] = useState(null);
  const [tratamentoNovo, setTratamentoNovo] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [diferencaValor, setDiferencaValor] = useState(0);

  useEffect(() => {
    fetchTratamentos();
  }, []);

  useEffect(() => {
    // Atualizar visibilidade e validação quando o tratamento atual mudar
    if (tratamentoAtual) {
      configurarCamposDentesEFaces(tratamentoAtual);

      // Se o tratamento aceita dentes e tem apenas 1 dente disponível, selecionar automaticamente
      if (tratamentoAtual.aceitaDentes && tratamentoAtual.dentesEspecificos) {
        const dentesDisponiveis = tratamentoAtual.dentesEspecificos
          .split(",")
          .map((d) => d.trim());
        if (dentesDisponiveis.length === 1) {
          setDentes(dentesDisponiveis);
          validarDentes(dentesDisponiveis, tratamentoAtual);
        }
      }
    }
  }, [tratamentoAtual]);

  const fetchTratamentos = async () => {
    try {
      startLoading();
      const tratamentosRetornados = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentos/clinica/${clinica.clinica._id}`,
        "GET",
        null,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      const tratamentosOrdenadosAlfabeticamente =
        tratamentosRetornados.tratamentos.sort((a, b) =>
          a.designacao.trim().localeCompare(b.designacao.trim())
        );

      const tempTratamentosAutocomplete =
        tratamentosOrdenadosAlfabeticamente.map((t) => ({
          id: t._id,
          label: t.fornecedor?.nome
            ? `${t.designacao.trim()} (${t.fornecedor.nome})`
            : t.designacao.trim(),
        }));

      setTratamentos(tempTratamentosAutocomplete);
      setAllTratamentos(tratamentosOrdenadosAlfabeticamente);

      // Guardar informações do tratamento original
      if (dados.tratamento) {
        const tratOriginal = tratamentosOrdenadosAlfabeticamente.find(
          (t) => t._id === dados.tratamento._id
        );
        setTratamentoOriginal(tratOriginal);
        setTratamentoAtual(tratOriginal);
      } else {
        // Sem tratamento específico - apenas categoria
        setTratamentoOriginal(null);
        setTratamentoAtual(null);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const configurarCamposDentesEFaces = (tratamento) => {
    // Configurar lista de dentes disponíveis
    if (tratamento.dentesEspecificos) {
      setListaDentes(tratamento.dentesEspecificos.split(", "));
    } else {
      setListaDentes(todosOsDentes);
    }

    // Configurar visibilidade de dentes
    setShowDentes(tratamento.aceitaDentes);

    // Configurar visibilidade de faces
    const dentesQueNaoAceitamFaces = [
      "Arcadas",
      "Arcada Superior",
      "Arcada Inferior",
    ];
    const dentesSelecionadosSaoArcadas = dentes.some((d) =>
      dentesQueNaoAceitamFaces.includes(d)
    );

    setShowFaces(
      tratamento.aceitaFaces &&
        !dentesSelecionadosSaoArcadas &&
        !(
          tratamento.dentesEspecificos &&
          dentesQueNaoAceitamFaces.includes(tratamento.dentesEspecificos)
        )
    );

    // Limpar seleções inválidas
    if (!tratamento.aceitaDentes) {
      setDentes([]);
      setErroDentes("");
    }

    if (!tratamento.aceitaFaces || dentesSelecionadosSaoArcadas) {
      setFaces([]);
      setErroFaces("");
    }

    // Validar seleções existentes
    validarDentes(dentes, tratamento);
    validarFaces(faces, tratamento);
  };

  const validarDentes = (dentesArray, tratamento) => {
    if (!tratamento.aceitaDentes || tipoModal === "ver") {
      setErroDentes("");
      return true;
    }

    if (dentesArray.length === 0) {
      setErroDentes("Por favor selecione os dentes a tratar");
      return false;
    }

    if (tratamento.multiDentes) {
      if (dentesArray.length % tratamento.qtdDentes !== 0) {
        setErroDentes(
          `O tratamento ${tratamento.designacao} requer múltiplos de ${tratamento.qtdDentes} dentes. Foram selecionados ${dentesArray.length} dentes.`
        );
        return false;
      }
    }
    setErroDentes("");
    return true;
  };

  const validarFaces = (facesArray, tratamento) => {
    if (!tratamento.aceitaFaces || !showFaces || tipoModal === "ver") {
      setErroFaces("");
      return true;
    }

    if (facesArray.length === 0) {
      setErroFaces("Por favor selecione as faces a tratar");
      return false;
    }

    if (tratamento.qtdFaces < 5 && facesArray.length !== tratamento.qtdFaces) {
      setErroFaces(
        `O tratamento ${tratamento.designacao} exige exatamente ${tratamento.qtdFaces} face(s). Foram selecionadas ${facesArray.length}.`
      );
      return false;
    }

    if (tratamento.qtdFaces === 5 && facesArray.length > 5) {
      setErroFaces("Não é possível selecionar mais de 5 faces");
      return false;
    }

    setErroFaces("");
    return true;
  };

  const dentesChangeHandler = (event) => {
    const {
      target: { value },
    } = event;
    const selectedDentes = typeof value === "string" ? value.split(",") : value;

    // Lógica especial para arcadas
    if (selectedDentes.includes("Arcadas")) {
      setDentes(["Arcadas"]);
      setFaces([]);
      setShowFaces(false);
    } else if (
      selectedDentes.includes("Arcada Superior") ||
      selectedDentes.includes("Arcada Inferior")
    ) {
      const apenasArcadas = selectedDentes.filter(
        (d) => d === "Arcada Superior" || d === "Arcada Inferior"
      );
      setDentes(apenasArcadas);
      setFaces([]);
      setShowFaces(false);
    } else {
      setDentes(selectedDentes);
      // Reconfigurar faces baseado no tratamento atual
      if (
        tratamentoAtual &&
        tratamentoAtual.aceitaFaces &&
        selectedDentes.length > 0
      ) {
        setShowFaces(true);
      }
    }

    validarDentes(selectedDentes, tratamentoAtual);
  };

  const facesChangeHandler = (event) => {
    const {
      target: { value },
    } = event;
    const selectedFaces = typeof value === "string" ? value.split(",") : value;

    setFaces(selectedFaces);
    validarFaces(selectedFaces, tratamentoAtual);
  };

  const tratamentoChangeHandler = (e) => {
    const novoTratamentoId = e.target.value;

    // Se a entrada já foi recebida, não permitir alteração
    if (dados.entrada && dados.entrada.entradaRecebida) {
      toast.error(
        "Não é possível alterar o tratamento pois o pagamento já foi processado"
      );
      return;
    }

    // Se está a mudar para um tratamento diferente do original
    if (novoTratamentoId !== (dados.tratamento?._id || "")) {
      const novoTratamento = allTratamentos.find(
        (t) => t._id === novoTratamentoId
      );
      setTratamentoNovo(novoTratamento);

      if (dados.entrada) {
        // Calcular diferença de valor
        const diferenca =
          novoTratamento.preco_particular - tratamentoOriginal.preco_particular;
        setDiferencaValor(diferenca);

        // Mostrar diálogo de confirmação
        setShowConfirmDialog(true);
      } else {
        setSelectedProcedure(novoTratamento._id);
        setTratamentoAtual(novoTratamento);
        configurarCamposDentesEFaces(novoTratamento);
      }
    } else {
      // Voltou ao tratamento original
      setSelectedProcedure(novoTratamentoId);
      setTratamentoAtual(tratamentoOriginal);
      setTratamentoNovo(null);
      setDiferencaValor(0);
    }
  };

  const handleConfirmTratamentoChange = () => {
    setSelectedProcedure(tratamentoNovo._id);
    setTratamentoAtual(tratamentoNovo);
    setShowConfirmDialog(false);

    // Reconfigurar e revalidar dentes e faces para o novo tratamento
    configurarCamposDentesEFaces(tratamentoNovo);
  };

  const handleCancelTratamentoChange = () => {
    setTratamentoNovo(null);
    setDiferencaValor(0);
    setShowConfirmDialog(false);
  };

  const validarFormulario = () => {
    // Se não há tratamento selecionado, não pode executar
    if (!selectedProcedure) {
      toast.error("Por favor selecione um tratamento para executar");
      return false;
    }
    if (!tratamentoAtual) return false;

    const dentesValidos = validarDentes(dentes, tratamentoAtual);
    const facesValidas = validarFaces(faces, tratamentoAtual);

    return dentesValidos && facesValidas;
  };

  const submitHandler = async () => {
    if (!validarFormulario()) {
      toast.error("Por favor corrija os erros antes de continuar");
      return;
    }

    startLoading();
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append(
        "relatorio",
        relatorio || "Tratamento isolado executado com sucesso!"
      );
      formData.append("data_inicio_execucao", dataInicioExecucao);
      formData.append("data_fim_execucao", dataFimExecucao);
      formData.append("atendido", true);
      formData.append("utilizador", auth.userId);

      // Adicionar dentes e faces
      if (showDentes && dentes.length > 0) {
        formData.append("dente", dentes.join(","));
      }

      if (showFaces && faces.length > 0) {
        faces.forEach((face) => formData.append("faces", face));
      }

      // Se houve alteração de tratamento
      if (selectedProcedure !== (dados.tratamento?._id || "")) {
        const tratamentoExecutado = allTratamentos.find(
          (t) => t._id === selectedProcedure
        );

        // Criar texto de alteração
        const textoAlteracao = tratamentoOriginal
          ? `[ALTERAÇÃO DE TRATAMENTO]\n` +
            `Original: ${
              tratamentoOriginal.designacao
            } (${tratamentoOriginal.preco_particular.toLocaleString(
              "pt-Br"
            )}CVE)\n` +
            `Executado: ${
              tratamentoExecutado.designacao
            } (${tratamentoExecutado.preco_particular.toLocaleString(
              "pt-Br"
            )}CVE)\n` +
            `Diferença: ${
              diferencaValor > 0 ? "+" : ""
            }${diferencaValor.toLocaleString("pt-Br")}CVE\n` +
            `Data/Hora: ${moment().format("DD/MM/YYYY HH:mm")}\n` +
            `Alterado por: ${auth.nome || auth.userId}`
          : `[SELEÇÃO DE TRATAMENTO]\n` +
            `Categoria Original: ${
              dados.categoriaTratamento?.categoria || "N/A"
            }\n` +
            `Tratamento Selecionado: ${
              tratamentoExecutado.designacao
            } (${tratamentoExecutado.preco_particular.toLocaleString(
              "pt-Br"
            )}CVE)\n` +
            `Data/Hora: ${moment().format("DD/MM/YYYY HH:mm")}\n` +
            `Selecionado por: ${auth.nome || auth.userId}`;

        formData.append("alteracaoTratamento", textoAlteracao);
        formData.append("tratamento", selectedProcedure);
        if (dados.entrada) {
          let valorFinal;
          let numeroExecucoes = 1;

          if (dentes.length > 0) {
            if (tratamentoExecutado.multiDentes) {
              // Para multiDentes: calcular número de execuções
              numeroExecucoes = dentes.length / tratamentoExecutado.qtdDentes;
              valorFinal =
                numeroExecucoes * tratamentoExecutado.preco_particular;
            } else {
              // Para tratamentos normais: cada dente é uma execução
              numeroExecucoes = dentes.length;
              valorFinal =
                numeroExecucoes * tratamentoExecutado.preco_particular;
            }
          } else {
            valorFinal = tratamentoExecutado.preco_particular;
          }

          formData.append("novoValorEntrada", valorFinal);
        }
      }

      let tratamentoIsoladoRetornada;
      try {
        tratamentoIsoladoRetornada = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/executar/${dados._id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        toast.success("Tratamento Isolado executado com sucesso!");
      } catch (err) {
        console.error("err", err);
      }

      setIsSubmitting(false);

      const tempTratamentoRetornado = {
        ...tratamentoIsoladoRetornada.tratamentoIsolado,
        data_inicio_execucao: moment(
          tratamentoIsoladoRetornada.tratamentoIsolado.data_inicio_execucao
        ).format("DD-MM-YYYY HH:mm"),
        data_fim_execucao: moment(
          tratamentoIsoladoRetornada.tratamentoIsolado.data_fim_execucao
        ).format("DD-MM-YYYY HH:mm"),
      };

      handleModalSubmitSuccess(tempTratamentoRetornado);
      handleCloseModal();
    } catch (err) {
      console.error("err", err);
      toast.error("Erro ao executar tratamento");
    } finally {
      stopLoading();
    }
  };

  // Verificar se o select deve estar desabilitado
  const isTratamentoSelectDisabled =
    tipoModal === "ver" || (dados.entrada && dados.entrada.entradaRecebida);

  const selectPlaceholder = dados.tratamento
    ? "Selecione um tratamento"
    : "Nenhum tratamento específico foi selecionado inicialmente";

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          <h1 style={{ marginBottom: 24 }}>
            {tipoModal === "ver" ? "Ver " : "Executar "}Tratamento -{" "}
            {dados.cliente.nome}
          </h1>

          <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                label="Data Início"
                inputFormat="DD-MM-YYYY HH:mm"
                value={dataInicioExecucao}
                onChange={(value) => setDataInicioExecucao(value)}
                renderInput={(params) => <TextField {...params} fullWidth />}
                readOnly={tipoModal === "ver"}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                label="Data Fim"
                inputFormat="DD-MM-YYYY HH:mm"
                value={dataFimExecucao}
                onChange={(value) => setDataFimExecucao(value)}
                renderInput={(params) => <TextField {...params} fullWidth />}
                readOnly={tipoModal === "ver"}
              />
            </LocalizationProvider>
          </div>

          {dados.categoriaTratamento && !dados.tratamento && (
            <Alert severity="info" sx={{ mb: 2 }}>
              <AlertTitle>Categoria de Tratamento</AlertTitle>
              <strong>Categoria:</strong> {dados.categoriaTratamento.categoria}
              {tipoModal === "executar" && (
                <>
                  <br />
                  <em>
                    Este tratamento isolado foi criado com uma categoria.
                    Selecione um tratamento específico abaixo para executar.
                  </em>
                </>
              )}
            </Alert>
          )}

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="tratamento-label">Tratamento*</InputLabel>
            <Select
              labelId="tratamento-label"
              id="tratamento-select"
              value={selectedProcedure}
              onChange={tratamentoChangeHandler}
              disabled={isTratamentoSelectDisabled}
              label="Tratamento*"
            >
              <MenuItem value="">{selectPlaceholder}</MenuItem>
              {tratamentos.map((procedure, index) => (
                <MenuItem value={procedure.id} key={index}>
                  {procedure.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Campo de Dentes */}
          {showDentes && (
            <FormControl fullWidth sx={{ mb: 2 }} error={!!erroDentes}>
              <InputLabel id="dentes-label">Dentes*</InputLabel>
              <Select
                labelId="dentes-label"
                multiple
                value={dentes}
                onChange={dentesChangeHandler}
                input={<OutlinedInput label="Dentes*" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
                disabled={tipoModal === "ver"}
              >
                {listaDentes.map((dente) => (
                  <MenuItem key={dente} value={dente}>
                    <Checkbox checked={dentes.indexOf(dente) > -1} />
                    <ListItemText primary={dente} />
                  </MenuItem>
                ))}
              </Select>
              {erroDentes && (
                <span
                  style={{
                    color: "#d32f2f",
                    fontSize: "0.75rem",
                    marginTop: "3px",
                  }}
                >
                  {erroDentes}
                </span>
              )}
            </FormControl>
          )}

          {/* Campo de Faces */}
          {showFaces && (
            <FormControl fullWidth sx={{ mb: 2 }} error={!!erroFaces}>
              <InputLabel id="faces-label">Faces*</InputLabel>
              <Select
                labelId="faces-label"
                multiple
                value={faces}
                onChange={facesChangeHandler}
                input={<OutlinedInput label="Faces*" />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
                disabled={tipoModal === "ver"}
              >
                {facesDentes.map((face) => (
                  <MenuItem key={face} value={face}>
                    <Checkbox checked={faces.indexOf(face) > -1} />
                    <ListItemText primary={face} />
                  </MenuItem>
                ))}
              </Select>
              {erroFaces && (
                <span
                  style={{
                    color: "#d32f2f",
                    fontSize: "0.75rem",
                    marginTop: "3px",
                  }}
                >
                  {erroFaces}
                </span>
              )}
            </FormControl>
          )}

          {selectedProcedure &&
            tratamentoAtual &&
            dentes.length > 0 &&
            !dentes.some((d) =>
              ["Arcadas", "Arcada Superior", "Arcada Inferior"].includes(d)
            ) &&
            (() => {
              const numeroExecucoes = tratamentoAtual.multiDentes
                ? dentes.length / tratamentoAtual.qtdDentes
                : dentes.length;

              return numeroExecucoes > 1 ? (
                <Alert severity="info" sx={{ mb: 2 }}>
                  <AlertTitle>Múltiplas Execuções</AlertTitle>
                  Será executado:{" "}
                  <strong>
                    {numeroExecucoes}× {tratamentoAtual.designacao}
                  </strong>
                  <br />
                  Dentes: <strong>{dentes.join(", ")}</strong>
                  {tratamentoAtual.multiDentes && (
                    <>
                      <br />
                      <em>
                        ({numeroExecucoes} grupos de {tratamentoAtual.qtdDentes}{" "}
                        dentes)
                      </em>
                    </>
                  )}
                  {dados.entrada && (
                    <>
                      <br />
                      Valor total:{" "}
                      <strong>
                        {(
                          tratamentoAtual.preco_particular * numeroExecucoes
                        ).toLocaleString("pt-Br")}{" "}
                        CVE
                      </strong>
                      <br />
                      <em>
                        ({numeroExecucoes} ×{" "}
                        {tratamentoAtual.preco_particular.toLocaleString(
                          "pt-Br"
                        )}{" "}
                        CVE)
                      </em>
                    </>
                  )}
                </Alert>
              ) : null;
            })()}

          {/* Aviso se entrada já foi recebida */}
          {dados.entrada &&
            dados.entrada?.entradaRecebida &&
            tipoModal !== "ver" && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                <AlertTitle>Tratamento bloqueado</AlertTitle>O pagamento já foi
                processado. Não é possível alterar o tratamento.
              </Alert>
            )}

          {/* Mostrar informação de alteração se existir */}
          {dados.alteracaoTratamento && (
            <Alert severity="info" sx={{ mb: 2 }}>
              <AlertTitle>Histórico de Alteração</AlertTitle>
              <pre
                style={{
                  margin: 0,
                  fontFamily: "inherit",
                  whiteSpace: "pre-wrap",
                }}
              >
                {dados.alteracaoTratamento}
              </pre>
            </Alert>
          )}

          {/* Mostrar informações de dentes e faces já salvos */}
          {tipoModal === "ver" &&
            (dados.dente || (dados.faces && dados.faces.length > 0)) && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <AlertTitle>Detalhes do Tratamento</AlertTitle>
                {dados.dente && (
                  <div>
                    <strong>Dente(s):</strong> {dados.dente}
                  </div>
                )}
                {dados.faces && dados.faces.length > 0 && (
                  <div>
                    <strong>Face(s):</strong> {dados.faces.join(", ")}
                  </div>
                )}
              </Alert>
            )}

          <div style={{ marginBottom: 16 }}>
            <TextField
              fullWidth
              multiline
              rows={5}
              placeholder={
                tipoModal === "ver" && (!relatorio || relatorio.trim() === "")
                  ? "Nenhum relatório por mostrar!"
                  : "Escreva aqui o relatório do tratamento."
              }
              value={relatorio}
              onChange={(e) => setRelatorio(e.target.value)}
              InputProps={{
                readOnly: tipoModal === "ver",
              }}
              variant="outlined"
              label="Relatório"
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 24,
            }}
          >
            {tipoModal === "executar" && (
              <Button
                disabled={isSubmitting}
                variant="contained"
                onClick={submitHandler}
                sx={{ textTransform: "none" }}
              >
                {isSubmitting ? "Guardando..." : "Executar"}
              </Button>
            )}
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              sx={{ textTransform: "none" }}
            >
              Fechar
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Diálogo de confirmação para alteração de tratamento */}
      <Dialog
        open={showConfirmDialog}
        onClose={handleCancelTratamentoChange}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Confirmar Alteração de Tratamento
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <strong>Tratamento Original:</strong>{" "}
            {tratamentoOriginal?.designacao} (
            {tratamentoOriginal?.preco_particular.toLocaleString("pt-Br")}CVE)
            <br />
            <strong>Novo Tratamento:</strong> {tratamentoNovo?.designacao} (
            {tratamentoNovo?.preco_particular.toLocaleString("pt-Br")}CVE)
            <br />
            <strong>Diferença:</strong>
            <span
              style={{
                color: diferencaValor > 0 ? "#2e7d32" : "#d32f2f",
                fontWeight: "bold",
              }}
            >
              {diferencaValor > 0 ? " +" : " "}
              {Math.abs(diferencaValor).toLocaleString("pt-Br")}CVE
            </span>
            <br />
            <br />
            {tratamentoNovo && (
              <Alert severity="info">
                <strong>Requisitos do novo tratamento:</strong>
                <br />
                {tratamentoNovo.aceitaDentes && (
                  <>
                    • Requer seleção de dente(s)
                    {tratamentoNovo.multiDentes &&
                      ` (exatamente ${tratamentoNovo.qtdDentes})`}
                    <br />
                  </>
                )}
                {tratamentoNovo.aceitaFaces && (
                  <>
                    • Requer seleção de face(s)
                    {tratamentoNovo.qtdFaces < 5 &&
                      ` (exatamente ${tratamentoNovo.qtdFaces})`}
                  </>
                )}
                {!tratamentoNovo.aceitaDentes &&
                  !tratamentoNovo.aceitaFaces &&
                  "• Não requer seleção de dentes ou faces"}
              </Alert>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelTratamentoChange} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmTratamentoChange}
            color="primary"
            autoFocus
          >
            Confirmar Alteração
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ModalVerEditarTratamentoIsolado;
